import SettingsChannel from './Settings/SettingsChannel'


export default class ChatterChannel {

  constructor(store) {
    this.store = store;
    /* In order to remove the activity stream, we will need to figure out an alternative way of keeping the account a user is viewing alive. */
    this.settings = new SettingsChannel(this.store);

  }
}
